module.exports = __webpack_public_path__ + "static/Antwork-98cc76589dedcd00bba48f808c1766e8.png";